import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate, useRouteContext } from '@tanstack/react-router';
import { useCallback, useEffect } from 'react';

import { getGetAiAgentQueryKey, getListAgentWebhookDeliveriesQueryKey } from '../../../../../api';
import { AgentWebhookPanel } from '../../../../../modules/ai-agent/components';
import { useGetAiAgentQuery } from '../../../../../modules/ai-agent/hooks';

const AgentWebhookRoute = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { selectedOrganization } = useRouteContext({ from: '/_authenticated/_app' });
  const { agentId } = Route.useParams();
  const organizationId = selectedOrganization.id;

  const { data: agentResponse } = useGetAiAgentQuery(organizationId, agentId);
  const agentData = agentResponse?.data;

  useEffect(() => {
    if (agentData?.state === 'draft') {
      navigate({
        to: '/agents/$agentId',
        params: { agentId },
        replace: true,
      });
    }
  }, [agentData?.state, navigate, agentId]);

  const handleWebhookChange = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: getGetAiAgentQueryKey(organizationId, agentId),
    });
    queryClient.invalidateQueries({
      queryKey: getListAgentWebhookDeliveriesQueryKey(organizationId, agentId),
    });
  }, [queryClient, organizationId, agentId]);

  if (!agentData || agentData.state === 'draft') return null;

  return (
    <div style={{ padding: '24px 24px 0' }}>
      <AgentWebhookPanel
        organizationId={organizationId}
        agentId={agentId}
        agentState={agentData.state}
        webhookEnabled={agentData.webhookEnabled}
        webhookUrl={agentData.webhookUrl}
        onWebhookChange={handleWebhookChange}
      />
    </div>
  );
};

export const Route = createFileRoute('/_authenticated/_app/agents/$agentId/webhook')({
  component: AgentWebhookRoute,
});
